{
	"ariaFinalizeAiStyleCreation": "Finalize AI Style Creation",
	"ariaShowPreviewPhotosAsGrid": "Show Preview Photos As Grid",
	"ariaShowSinglePreviewPhoto": "Show Single Preview Photo",
	"ariaTogglePreviewBeforeAfter": "Toggle Preview Photos Before And After View",
	"ariaTuneAdjustment": "Tune Adjustment {{name}}",
	"finalizeTitle": "Finalize AI Style Creation",
	"labelBrighter": "Brighter",
	"labelCooler": "Cooler",
	"labelContrast": "Contrast",
	"labelDarker": "Darker",
	"labelExposure": "Exposure",
	"labelGreen": "Green",
	"labelMagenta": "Magenta",
	"labelMuted": "Muted",
	"labelSaturation": "Saturation",
	"labelSofter": "Softer",
	"labelStronger": "Stronger",
	"labelTemperature": "Temperature",
	"labelTint": "Tint",
	"labelVibrant": "Vibrant",
	"labelWarmer": "Warmer",
	"previewDescription": "Every photoshoot is different. Tune your color preferences to best suit this shoot.",
	"previewTune": "Preview & tune AI Style",
	"tooltipBeforeAfter": "Before/After (\\)"
}
